/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo200,
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo401,
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo403,
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo404,
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo500,
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfoPathParams,
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfoQueryResponse,
} from "../../types/documentCourseRegistrationController/GetApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo.ts";

export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfoPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
    cultureInfo: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfoPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo200Schema =
  z.instanceof(
    File,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo401>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo403Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo403>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo404Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo500>;

export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfoQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfo200Schema,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseContractCultureinfoQueryResponse>;
